<div class="map-container">
  <header-panel></header-panel>
  <main-map></main-map>
  <layer-control></layer-control>
  <legend></legend>
  <base-map-switch></base-map-switch>
  <tools></tools>
</div>

<!-- z-index of over-map is on top of map-container -->
<div class="over-map">


  <!-- Fill space above footer Section -->
  <div class="fill-container"></div>

  <!-- Footer Section -->
  <div class="footer-container" #footerContainerRef>
    <!-- Bottom Panel -->
    <bottom-panel
      #bottomPanelRef
      [ngStyle]="{
        display: bottomPanelIsInvisible === true ? 'none' : 'inherit'
      }"
    ></bottom-panel>
  </div>
</div>
<router-outlet></router-outlet>
